"use client";

import { useEffect, useState } from "react";
import { isLocalPreviewPublicHost } from "./public-location-cookie";

export function useBrowserPublicHost(initialPublicHost?: string) {
  const [browserPublicHost, setBrowserPublicHost] =
    useState<string | undefined>(initialPublicHost);

  useEffect(() => {
    if (initialPublicHost && !isLocalPreviewPublicHost(initialPublicHost)) {
      return;
    }

    setBrowserPublicHost(`${window.location.protocol}//${window.location.host}`);
  }, [initialPublicHost]);

  return browserPublicHost;
}
